<template>
    <p class="mb-0">
        <span :class="['main-text', largeMobileValue ? 'large-main-text' : 'small-main-text']">
            {{ formatCurrency(offer.total_repayment) }}
        </span>

        <span class="small-text d-flex align-self-start">
            {{ $t('results.totalRepayment') }}
        </span>
    </p>
</template>

<script>
import { formatCurrency } from '@js/utilities/number.js'

export default {
    props: {
        largeMobileValue: {
            type: Boolean,
            default: true,
        },
    },
    inject: ['offer'],
    methods: {
        formatCurrency: formatCurrency,
    },
}
</script>
